import { buildApiRequest } from 'utils/api';
import { urls } from 'utils/urls';

const urlHelper = {
  fetchRateInfos: (demandId) => buildApiRequest('GET', `${urls.getRateInfo()}?demand-id=${demandId}`),
};
export default urlHelper;
